
// import orderSend from '../components/orderSend.vue'
import store from '@/store'
import vue from 'vue'
import viewPage from '../components/viewPage.vue'
import orderStatus from './../components/orderStatus.vue'
import statusSelected from './../components/statusSelect.vue'
import statusSwitch from './../components/statusSwitch.vue'
import DeleteOrder from '../components/orderDelete.vue'
// import NP from 'number-precision'
const that = vue.prototype
export default {
  className: 'Order',
  title: '备货订单',
  perPage: 30,
  mixin: {
    fields: [
      {
        // 所属用户
        name: 'userid',
        note: '销售人员',
        width: 80,
        validators: [
          val => (val) ? null : '销售员不可为空'
        ]
      },
      {
        name: 'userid.username',
        width: 110,
        note: '经理电话'
      },
      {
        // 型号
        name: 'finishProductid',
        width: 80,
        validators: [
          val => (val) ? null : '成品型号不可为空'
        ]
      },
      {
        // 麦头
        name: 'markid',
        width: 80,
      },
      {
        // 包装
        name: 'packid',
        width: 80,
      },
      {
        // 托盘
        name: 'palletid',
        width: 80,
      },
      {
        // 状态
        name: 'status',
        width: 100,
        view: {
          component: orderStatus
        },
        search: {
          component: statusSelected
        }
      },
      {
        // 吨数
        name: 'amount',
        width: 80,
        validators: [
          val => (val) ? null : '吨数不可为空'
        ]
      },
      {
        // 运费
        name: 'shipping',
        width: 80,
      },
      {
        name: 'clientid.name',
        width: 110
      },
      {
        name: 'clientid.phone',
        width: 130
      },
      {
        name: 'clientid.address',
        width: 110
      },
      {
        name: 'clientid.linkman',
        width: 80
      },
      {
        // 下单日期
        name: 'orderDate',

        note: '下单日期'
      },
      {
        // 交付日期
        name: 'shipDate',
      },

      {
        // 备注
        name: 'remarks',
        width: 80
      },
      {
        name: 'updatedAt',
      }

    ],
  },
  search: [
    'finishProductid',
    'status',
    'orderDate',
    'updatedAt'
  ],
  action: {
    view: store.state.user && store.state.user.authority.reserveOrder && store.state.user.authority.reserveOrder.view
      ? {
        type: 'row',
        text: '查看',
        component: viewPage
      }
      : false,
    // edit: store.state.user && store.state.user.authority.reserveOrder.edit
    //   ? {} : false,
    edit: store.state.user && store.state.user.authority.reserveOrder && store.state.user.authority.reserveOrder.edit
      ? {
        type: 'row',
        text: '变更状态',
        title: '变更状态',
        component: statusSwitch
      } : false,
    delete: false,
    myDelete: store.state.user && store.state.user.authority.reserveOrder.del
      ? {
        type: 'row',
        text: '删除',
        component: DeleteOrder
      }
      : false,
    cancelReserve: store.state.user && store.state.user.authority.reserveOrder && store.state.user.authority.reserveOrder.cancelReserve
      ? {
        type: 'row',
        text: '取消备货',
        callback: async ({ record, vm, modelName }) => {
          console.log(record)
          await vm.confirm('提示', '确认此订单取消备货？')
          let rs = null
          try {
            rs = await vm.$modelAjax.put(modelName, record.objectId, {
              isReserve: false
            })
          } catch (e) {
            vm.$notification.error({
              message: '网络错误',
              description: '网络错误'
            })
          }
          if (rs) {
            vm.$notification['success']({
              message: '操作成功',
              description: '此订单取消备货'
            })
          }
          vm.refresh()
          switch (record.status) {
            case 'add':
              that.$tkParse.post('/sendMessage/sendToOwner', { record: record, status: '新增订单' })
              break
            case 'read':
              that.$tkParse.post('/sendMessage/sendToOwner', { record: record, status: '已读订单' })
              break
            case 'madeing':
              that.$tkParse.post('/sendMessage/sendToOwner', { record: record, status: '生产中订单' })
              break
            case 'complete':
              that.$tkParse.post('/sendMessage/sendToOwner', { record: record, status: '生产完成订单' })
              that.$tkParse.post('/sendMessage/sendToStaff', { record: record, status: '生产完成订单' })
              break
          }
        }
      } : false
  },
  hooks: {
    beforeFetch ({ where }) {
      if (!where.status) {
        where.status = {
          $in: ['add', 'read', 'madeing', 'complete']
        }
      }
      if (where.status === 'null') {
        delete where.status
      }
      where.isReserve = true
      // 查看所有订单
      if (store.state.user && store.state.user.allShopManagements === 'Yes') {

      } else {
        // where.shopManagementid = {
        //   $in: store.state.user.shopManagements
        // }
        where.finishProductid = {
          $inQuery: {
            where: {
              workShop: {
                $inQuery: {
                  where: {
                    objectId: { $in: store.state.user.shopManagements }
                  },
                  className: 'shopManagement'
                }
              }
            },
            className: 'finishProduct'
          }
        }
      }
      if (store.state.user && store.state.user.allClient === 'Yes') { } else {
        where.userid = store.state.user.objectId
      }
    }
  }
}
